import React from 'react';
import { TopBar } from './TopBar';

const Auth = (props: {
  children: React.ReactNode,
  user: any | undefined
}) => {
  const authenticated = props.user !== undefined

  if (authenticated === false) {
    return (
      <div></div>
    );
  } else {
    return (
      <div className='App'>
        <TopBar user={props.user} />

        {props.children}
      </div>
    );
  }
};

export default Auth;
